import React, { Component } from "react"
import { one2six } from '../../variables/ComboValues' // , one2fiveTEXT
import { RadioSelect } from '../../elements/RadioSelect/RadioSelect'
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { updateElement } from "../Tree/Utils.js"
import { CalendarDay2 } from '../../elements/DayPicker/DayPicker2'


// ParentQuestionnaire Pre handles BOTH 
// input question list will define the type of qustionnaire
// the PRE for historical reasons

const  microLegend = {
//  "id": "מספר השאלון",
  "interviewer": "מראיין",
  "date": "תאריך מילוי השאלון",
  "q1": "במקרה הצורך יש לי במי להיעזר מחוץ למשפחה הגרעינית",
  "q2": "אנחנו נערכים ביחד (מדברים ומתכננים) לקראת הוצאות גדולות הצפויות בטווח הארוך (אירועים ושמחות, החלפת רכב, שיפוץ בית וכד')",
  "q3": "קשה לי להגיד ''לא'' לילדים כשהם מבקשים לקנות משהו",
  "q4": "לעיתים קרובות אני מרגיש/ה חסר שליטה בחיי ושאחרים או ''המצב'' מנהלים אותי",
  "q5": "צריך ליהנות מהחיים כמה שאפשר כי חיים רק פעם אחת",
  "q6": "למרות המצב הכלכלי שלי, יש עבודות שזו בושה בשבילי לעבוד בהן",
  "q7": "אני טורח/ת להתאמץ רק אם אני בטוח/ה מה ייצא מזה",
  "q8": "העתיד ומה שיקרה לנו תלוי בעיקר בי ובבת/בן זוגי",
  "q9": "הכישורים ו/או הניסיון שלי מאפשרים לי למצוא עבודה טובה",
  "q10": "כל אחד במשפחה יכול לתרום לשיפור המצב הכלכלי בדרך שלו",
  "q11": "אנחנו מתקשים להסתדר טוב ביחד במשפחה הגרעינית",
  "q12": "יש הרבה רגשות קשים במשפחה שלנו",
  "q13": "אני אעדיף לחתום אבטלה מאשר לעבוד תמורת אותו סכום של דמי אבטלה",
  "q14": "לפעמים אני מעדיף/ה לוותר מאשר להתעקש על מה שמגיע לי",
  "q15": "לילדים שההורים שלהם מפנקים אותם קשה לתפקד היטב בתור מבוגרים",
  "q16": "במשפחה שלנו מתקשים לקבל החלטות ביחד",
  "q17": "אני סומך/ת על הכוחות שלי בהתמודדות עם מצבים בחיים",
  "q18": "אם אעשה שינוי בחיים שלי אני עלול/ה לאבד את מה שיש לי עכשיו",
  "q19": "בתקופות של קושי אנחנו עוזרים אחד לשני במשפחה הגרעינית",
  "q20": "אוכל למצוא עבודה המתאימה ליכולותיי ולנטיותיי",
  "q21": "כאשר אני מגיע/ה לאחד המוסדות והרשויות, אני דורש/ת לקבל את מה שמגיע לי",
  "q22": "אנחנו פותרים בעיות ביחד במשפחה שלנו",
  "q23": "קשה לי להאמין שאצליח לשנות דברים שחשובים לי בחיים",
  "q24": "אני מרגיש/ה בודד/ה",
  "q25": "אני משקיע/ה מאמצים רבים כדי להשיג את המטרות שלי בחיים",
  "q26": "כיום, אני רחוק/ה מהמצב בו דמיינתי שאהיה כאשר חלמתי על העתיד שלי",
  "q27": "אני מרוצה מהמצב שלי בחיים",
  "q28": "אני מרגיש/ה אופטימי לגבי העתיד",
  "s1": "מצב הבריאות שלך, כולל בריאות השיניים",
  "s2": "המידה שיש לך מענה לצרכים הבסיסיים: מזון, הלבשה, קורת גג",
  "s3": "רמת החינוך שמקבלים ילדייך",
  "s4": "דרג את מידת ההערכה העצמית שלך",
  "s5": "המידה שבה אתה מממש את הפוטנציאל שלך עד היום",
  "s6": "מערכת היחסים שלך עם ילדייך",
  "s7": "מערכת היחסים שלך עם בן/ בת זוגך",
  "s8": "מערכת היחסים עם הקהילה שלך",
  "s9": "פעילות הפנאי שלך",
  "s10": "המצב הכלכלי שלך",
  "s11": "העבודה שלך",
  "s12": "מערכת התמיכה שלך (משפחה מורחבת, חברים, שכנים, אנשי מקצוע)",
  "r1": "רמת ההערכה העצמית שלך",
  "r2": "רמת האופטימיות שלך לעתידך האישי, המשפחתי המקצועי והכלכלי",
  "r3": "רמת הנכונות שלך להתאמץ כדי שנות דברים במצב המשפחתי שלך",
  "r4": "רמת הנכונות שלך להתאמץ כדי לשנות דברים במצב התעסוקתי שלך",
  "r5": "רמת נכונות שלך להתאמץ כדי לשפר את המצב הכלכלי שלך",
  "comments": "הערות נוספות"
}
export const questionnareFields = microLegend
export const ParentQuestionnaireFields = microLegend
export class ParentQuestionnairePre extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      //this.onSaveTable = this.onSaveTable.bind(this)
      //this.handleProductTable = this.handleProductTable.bind(this)
      //console.log("QQ", this.props.data.bench_stat)
    }
    handleProductTableDate = (day, key)  => {
      var newp = Object.assign(this.state.products)
      newp[key] = day
      this.setState({products:newp})
    }
    handleProductTable = (evt) => {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable = (evt) => {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      save2DB(memberPostId, this.state.products, subTableId, "group" )
    }
    render() {
      const {tableTitle} = this.props
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} 
            products={this.state.products} 
            onProductTableDate={this.handleProductTableDate}
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
          filterText : "",
          detailedDisplay: false
      }
      this.toggleDisplay = this.toggleDisplay.bind(this)
  }
  toggleDisplay(evt){
    let tog = !this.state.detailedDisplay
    this.setState({detailedDisplay: tog})
  }
    
  handleUserInput(filterText) {
      this.setState({filterText: filterText});
  }
  render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable, onProductTableDate } = this.props
      var buttonStyle = {marginRight: '0'}
      // console.log("General - products", products)
      var product = products
      var p = []
      for (const key in microLegend) {
        // console.log("microLegend: key="+key+" m[k]= "+ microLegend[key])
        let item = {
          type: "text",
          name: key,
          value: "",
          id: 1,
          edit: true
        }
        p.push(item)
      }
      if (products === undefined)
          product = p
      //console.log("BEFORE lloop- microLegend", product)

      var flist = []
      for (const key in microLegend) {
        // console.log("microLegend: key="+key+" m[k]= "+ microLegend[key])
        let item = {
          type: "text",
          name: key,
          value: product[key],
          id: product.id,
          edit: true
        }
        if (key[0] === 'q' && '0123456789'.indexOf(key[1]) !== -1) {
          item.type = "radioSelect" // ++++++++++++++++++++++++ was  "select"
          item.options = one2six // ["1-כלל לא", "2-במידה מעטה מאוד", "3- במידה מעטה","4-במידה בינונית", "5-במידה רבה", "6-במידה רבה מאוד"]
          if (key === "q1") // (key[1] === 1 && key.length <= 2)
            item.newsection= 'באיזו מידה המשפטים הבאים מתארים את ההרגשה שלך?'
          // item.value = key + ". " + item.value
        } else if ((key[0] === 's' || key[0] === 'r') && '0123456789'.indexOf(key[1]) !== -1) {
          item.type = "radioSelect" // ++++++++++++++++++++++++ was  "select"
          item.options = one2six // one2fiveTEXT // ["1-כלל לא", "2-מעטה", "3-בינונית", "4-רבה", "5-רבה מאוד"]
          if (key === 's1') 
                item.newsection= 'באיזו מידה את/ה מרוצה מהדברים הבאים?'
          if (key === 'r1') 
                item.newsection= 'איך היית מדרג/ת את הדברים הבאים?'
        } else if (key === "comments") {
          item.type = "textarea"
        } else if (key === 'date'){
          item.placeholder = 'dd/mm/yyyy'
          item.type = 'date'
          // item.style = 'display:inline-block;marginLeft:348px'
        }
        flist.push(item)
      }
      const cellData = flist
       
      return (
        <div className="sub-tab">

            <h2 className="sub-tab-title">{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left update-button" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform evenodd" >
                <button style={buttonStyle} type="button"  className="btn btn-success pull-left" 
                                            onClick={this.toggleDisplay}>שינוי תצוגה</button>
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    onProductTableDate = { onProductTableDate}
                    product={product} 
                    cd={cellData}
                    detailedDisplay = {this.state.detailedDisplay}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd, detailedDisplay, onProductTableDate} = this.props
      var key = 0;
      return (
        <div className="eachRow">
          {cd.map(cellInfo => {
              if (typeof cellInfo.newsection !== "undefined")
                return(
                <React.Fragment key={key++}>
                  <h3 key={key++} >{cellInfo.newsection}</h3>
                  <EditableFormCell key={cellInfo.name /*key++*/} onProductTableUpdate={onProductTableUpdate} 
                            cellData={cellInfo} detailedDisplay={detailedDisplay} onProductTableDate={onProductTableDate} />

                </React.Fragment>
                )
              return (<EditableFormCell key={cellInfo.name /*key++*/} onProductTableUpdate={onProductTableUpdate} 
                            cellData={cellInfo} detailedDisplay={detailedDisplay} onProductTableDate={onProductTableDate} /> )
          })}
        </div>
      )
    }
  }

class EditableFormCell extends React.Component {
  handleChange = changeEvent => {
    this.setState({date: changeEvent.target.value})
    //this.props.onChange(changeEvent)
  }

  render(){
    const tp = this.props
    const detailedDisplay = tp.detailedDisplay
    const tpc = tp.cellData
    const divStyleBblock = {padding: 0, verticalAlign: 'top', borderTop: 0, display: 'block', margin: '0 3px 5px 8px' }
    const labelStyle = {width: '30%', verticalAlign: 'top'}
       if (tpc.type === "date"){
          return (
             <div className="form-cell-box-inline">
               <label htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
               {<CalendarDay2
                   tpc = {tpc}
                   value = {tpc.value}
                   selected={new Date()}
                   onChange={this.handleChange}
                   handleChangeDate={tp.onProductTableDate} // {this.handleChangeDate}
               />}
             </div>
           )
        }
        if (tpc.type === "radioSelect" || tpc.type === "select"){
          if (detailedDisplay)
            tpc.type = "radioSelect"
          else
            tpc.type = "select"
        }
        if (tpc.type === "select" || tpc.type === "radioSelect"){
          if (Array.isArray(tpc.value)) { // ugly way to clean up old DB definition
            tpc.value = tpc.value.toString();
            // console.log("Convert to string " + tpc.name + " value = " , tpc.value)
          }
          if (tpc.type === "select")
            return(
              <div className="form-line" style={{padding: 0, borderTop: 0, display: 'block',margin: '0 3px 0 8px'}}>
                <span style={{width:'2%', display:'inline-block',verticalAlign:'top',textAlign:'left',marginLeft:'1%'}}>{tpc.name+"."}</span>
                <label style={{ width: '50%'}} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
                <SelectF tp={tp} tpc={tpc} overstyle={{display: 'inline-block'}} />
              </div>
            )
          else // tpc.type === "radioSelect"
            return (
              <div className="form-line" style={divStyleBblock}>
                <span style={{width:'2%', display:'inline-block',verticalAlign:'top',textAlign:'left',marginLeft:'1%'}}>{tpc.name+"."}</span>
                <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
                <RadioSelect value={tpc.value} options={tpc.options} onChange={tp.onProductTableUpdate} id={tpc.id} name={tpc.name} />
              </div>
            )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-line" style={{padding: 0, borderTop: 0, display: 'block',margin: '0 3px 0 8px'}}>
              <label style={{width: '50%'}}  htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <TextareaF tpc={tpc} tp={tp} overstyle={{width:'40%'}} />
            </div>
          )
        }
        return (
          <div className="form-line" style={{padding: 0, borderTop: 0, display: 'block',margin: '0 3px 0 8px'}}>
             <label style={{width: '50%'}} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
             <InputF tpc={tpc} tp={tp} />
          </div>
        )
    }    
  }
